import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom';
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from 'reactstrap';
import adoptImg from 'assets/images/adopt.png';
import donateImg from 'assets/images/donate.png';

interface MenuProps {
    showMenu: boolean;
    toggleMenuPanel(): void;
}

const MenuOffcanvas: FC<MenuProps> = ({ showMenu, toggleMenuPanel }) => {
    const navigate = useNavigate();

    const goTo = (page: string) => {
        toggleMenuPanel();
        navigate(page);
    }



    return (
        <Offcanvas
            isOpen={showMenu}
            direction='end'
            fade
            id="menu"
            className="w-100 "
        >
            <OffcanvasHeader
                className='ms-auto'
            >
                <button className='btn-close btn-close-white'
                    onClick={_ => toggleMenuPanel()}
                />
            </OffcanvasHeader>
            <OffcanvasBody >

                <ul className="navbar-nav">
                    <li className='nav-item mb-4'>
                        <a className="dropdown-item" onClick={() => goTo('/adopt')}>
                            <img src={adoptImg} className='me-2' height='30px' />
                            How to Adopt
                        </a>
                    </li>
                    <li className='nav-item'>
                        <a className="dropdown-item" onClick={() => goTo('/donate')}>
                            <img src={donateImg} className='me-2' height='30px' />
                            Donate
                        </a>
                    </li>
                </ul>
            </OffcanvasBody>
        </Offcanvas>
    )
}

export default MenuOffcanvas;